import { render, staticRenderFns } from "./qa-cell.vue?vue&type=template&id=84096fba&scoped=true&"
import script from "./qa-cell.vue?vue&type=script&lang=ts&"
export * from "./qa-cell.vue?vue&type=script&lang=ts&"
import style0 from "./qa-cell.vue?vue&type=style&index=0&id=84096fba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84096fba",
  null
  
)

export default component.exports